import Skeleton from "react-loading-skeleton";

/**
 * Skeleton loader for the ReferralLinkDataPage.
 * Shows loading state for statistics cards, activity chart, and subscribers table.
 */
export function ReferralLinkDataSkeleton() {
	return (
		<div>
			{/* Header */}
			<div className="flex items-center justify-between">
				<Skeleton width={220} height={28} />
			</div>

			{/* Statistics Cards */}
			<div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
				{[...Array(4)].map((_, i) => (
					<div
						key={i}
						className="rounded-xl border border-base-content/10 bg-base-100 p-4"
					>
						<Skeleton width={80} height={14} className="mb-2" />
						<Skeleton width={60} height={32} />
					</div>
				))}
			</div>

			{/* Activity Chart Section */}
			<div className="mt-8">
				<div className="flex items-center justify-between">
					<div>
						<Skeleton width={80} height={20} className="mb-1" />
						<Skeleton width={160} height={14} />
					</div>
					<Skeleton width={120} height={32} borderRadius={8} />
				</div>
				<div className="mt-4 h-75 rounded-xl border border-base-content/10 bg-base-100 animate-pulse" />
			</div>

			{/* Subscribers Section */}
			<div className="mt-12">
				<Skeleton width={100} height={20} className="mb-1" />
				<Skeleton width={260} height={14} className="mb-4" />
				<div className="rounded-lg border border-base-content/10">
					<div className="border-b border-base-content/10 px-4 py-3">
						<div className="grid grid-cols-4 gap-4">
							<Skeleton width={60} height={14} />
							<Skeleton width={80} height={14} />
							<Skeleton width={70} height={14} />
							<Skeleton width={50} height={14} />
						</div>
					</div>
					{[...Array(5)].map((_, i) => (
						<div
							key={i}
							className="border-b border-base-content/5 px-4 py-3 last:border-0"
						>
							<div className="grid grid-cols-4 gap-4">
								<Skeleton width={100} height={16} />
								<Skeleton width={80} height={16} />
								<Skeleton width={70} height={16} />
								<Skeleton width={60} height={16} />
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
